<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Вилоятни танланг <span class="red">*</span></label>
                        <v-select
                                label="name"
                                v-model="dictionaryData.data.province"
                                :filterable="false"
                                :options="provinces"
                                :class="{invalid: $v.dictionaryData.data.province.id.$error}"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.province.id.$error">Туманни танланг</div>
                    </div>
                    <div class="form-group">
                        <label>Сана <span class="red">*</span></label>
                        <date-picker class="form-control" format="dd/MM/yyyy"
                                    v-model="analysisDate"
                                    :clear-button="true"
                                    :class="{invalid : $v.analysisDate.$error}">
                        </date-picker>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <textarea
                                class="form-control"
                                v-model="dictionaryData.data.description"
                                :class="{invalid: $v.dictionaryData.data.description.$error}"
                        ></textarea>
                    </div>
                    <div>
                        <button v-b-toggle.html-view1 class="all-btn m-1">Html view</button>
                        <b-collapse visible id="html-view1">
                            <div class="card">
                                <span class="ml-2" v-html="dictionaryData.data.description"></span>
                            </div>
                        </b-collapse>
                    </div>
                    <div class="mx-n3">
                        <DropZone code="marketAnalysis"
                                  folder="Settings"
                                  subFolder="MarketAnalysis"
                                  acceptedFiles="image/*"
                                  label="Илова *"
                                  view="BUILDING" :data="dictionaryData.applications"
                                  @change="(photos) => {dictionaryData.applications = photos}"
                        />
                        <!--:has-error="$v.dictionaryData.applications.$error"-->
                    </div>
                    <div class="form-group">
                      <label>Сортировка</label>
                      <numeric-input v-model="dictionaryData.sortOrder" :precision="0"></numeric-input>
                    </div>
                    <div class="form-group">
                      <div class="form-check pl-0">
                        <label class="form-check-label" style="padding-left:22px !important">
                          <input class="form-check-input" type="checkbox"
                                 v-model="dictionaryData.active">
                          <span class="form-check-sign"></span>
                          Холати
                        </label>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_MARKET_ANALYSIS_ADD')" @click="save" :disabled="processing">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="close">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import DropZone from '@/views/dropZone/DropZone'
    import DatePicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    import {required} from 'vuelidate/lib/validators';
    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import { VBToggle } from 'bootstrap-vue/es/directives/toggle/toggle'
    import initFilterModel from '@/shared/filter';

    export default {
        name: "RealEstateMarketAnalysisEditModal",
        components: {
            'b-modal': bModal,
            DropZone,
            'date-picker':DatePicker,
            BCollapse
        },
        directives: {
            'b-modal': bModalDirective,
            'b-toggle': VBToggle
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                dictionaryData: this.initData(),
                provinces: [],
                analysisDate: null
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        province: {
                            id: {
                                required: required
                            }
                        },
                        description: {
                            required: required
                        }
                    }
                    // applications: {
                    //     required: required,
                    //     minLength: minLength(1)
                    // }
                },
                analysisDate: {
                    required: required
                }
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'REAL_ESTATE_MARKET_ANALYSIS',
                    data: {
                        province: null,
                        description: ''
                    },
                    applications: [],
                    sortOrder: null,
                    active: true
                }
            },
            init() {
                const vm = this;
                vm.provinces = [];
                vm.filterProvince.search = '';
                this.$http.post('/province/list', vm.filterProvince)
                    .then(res => {
                        vm.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, name: d.name}))
                }
                return [];
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                if (this.analysisDate) {
                    this.dictionaryData.data.analysisDate = formatDate(this.analysisDate);
                }

                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save/real-estate/market-analysis',this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.dictionaryData = this.initData()
                            this.$emit('change')
                        }
                        vm.processing = false;
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            close() {
               this.show = false
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.init();
            this.$eventBus.$on('showRealEstateMarketAnalysisEditModal', (data) => {
                if (data) {
                    console.log(data)
                    this.dictionaryData = data
                    this.analysisDate = parseDate(this.dictionaryData.data.analysisDate)
                } else {
                    this.dictionaryData = this.initData();
                    this.analysisDate = null;
                }
                this.show = true;
            })
        }
    }
</script>

<style scoped>

</style>